<template>
    <ReferrerLayout :racingstars="$page.props.racingstars" :user="$page.props.user">
        <div class="bg-no-repeat bg-cover h-full" style="background-image: url('/images/jackpot-background.png')">
            <div class="md:pt-12 md:pb-8 mx-auto max-w-7xl" >

                <div>
                    <div class="px-4 sm:px-6 sm:text-center md:mx-auto lg:flex lg:items-center">

                        <div class="max-w-5xl mx-auto">
                            <ApplicationLogo class="h-16 w-auto mb-20 mx-auto" />
                            <h1 class="mt-4 text-4xl leading-6 font-bold text-white sm:leading-none lg:text-5xl xl:text-5xl uppercase">
                                <span class="md:block">Free £10 package, 5 chances to win the prize pool starting at £50!</span>
                                {{ ' ' }}
                                <span class="text-racing-stars-yellow md:block text-2xl pt-3">No deposit required!</span>
                            </h1>
                            <p class="mt-10 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                                The Prize pool increases once 50+ players have entered and then increases £1 per entry. If 2 or more players end the day with the same score, the prize pool is split between the winning players.
                            </p>
                        </div>
                    </div>
                    <div class="mt-14 lg:col-span-12 lg:flex lg:items-center">
                        <div class="bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg">
                            <div class="px-4 py-8 sm:px-10">
                                <div class="md:mt-6" v-if="!registerFormVisible">
                                    <form action="#" method="POST" class="space-y-6">
                                        <div>
                                            <label for="email" class="sr-only">Email</label>
                                            <input v-model="form.email" type="text" name="email" id="email" autocomplete="email" placeholder="Enter your email address" required="" class="block w-full shadow-sm focus:ring-racing-stars-yellow focus:border-racing-stars-yellow sm:text-sm border-gray-300 rounded-md" />
                                        </div>
                                        <div>
                                            <button type="button" @click="showRegisterForm()" class="font-semibold w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-black bg-racing-stars-yellow hover:bg-yellow-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow" :disabled="!form.email" :class="{ 'opacity-25 cursor-not-allowed': !form.email }">
                                                Create Your Account
                                            </button>
                                            <Link :href="route('login')" as="button" class="lg:hidden mt-4 font-semibold w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-black bg-racing-stars-yellow hover:bg-yellow-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-racing-stars-yellow">
                                                Login
                                            </Link>
                                        </div>
                                    </form>
                                </div>
                                <div v-else class="mt-6">
                                    <RegisterForm :ignore-dark-mode="true" :email="form.email"/>
                                </div>
                            </div>
                            <div class="px-4 py-6 bg-gray-50 border-t-2 border-gray-200 sm:px-10 rounded-b">
                                <p class="text-xs leading-5 text-gray-500">By signing up, you agree to our <Link :href="route('terms')" class="font-medium text-gray-900 hover:underline">Terms</Link> &amp; <Link :href="route('privacy')" class="font-medium text-gray-900 hover:underline">Privacy Policy</Link>.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ReferrerLayout>
</template>
<script>
import { ref, computed } from 'vue'
import GamblingCommissionLogo from '@/Jetstream/GamblingCommissionLogo'
import { Head, Link, usePage } from '@inertiajs/inertia-vue3';
import WebLayout from '@/Layouts/WebLayout.vue'
import RegisterForm from '@/Pages/Auth/Register.vue'
import Jackpots from '@/Pages/Home/Partials/Jackpots.vue'
import Tokens from '@/Pages/Home/Partials/Tokens.vue'
import Horses from '@/Pages/Home/Partials/Horses.vue'
import Bet from '@/Pages/Home/Partials/Bet.vue'
import Change from '@/Pages/Home/Partials/Change.vue'
import Points from '@/Pages/Home/Partials/Points.vue'
import Cta from '@/Pages/Home/Partials/CTA.vue'
import Faqs from '@/Pages/Home/Partials/FAQS.vue'
import FooterCta from '@/Pages/Home/Partials/FooterCTA.vue'
import { useForm } from '@inertiajs/inertia-vue3'
import ReferrerLayout from '@/Layouts/ReferrerLayout';
import ApplicationLogo from '@/Jetstream/ApplicationLogo'
export default {
    props: {
        nextRaceStartTime: String,
    },
    components: {
        ReferrerLayout,
        GamblingCommissionLogo,
        Link,
        WebLayout,
        RegisterForm,
        Jackpots,
        Tokens,
        Horses,
        Bet,
        Change,
        Points,
        Cta,
        Faqs,
        FooterCta,
        ApplicationLogo,
    },
    setup(props) {
        const currentRoute = route().current()
        const page = usePage()
        const registerFormVisible = ref(false)
        const form = useForm({
            email: ''
        })
        const showRegisterForm = () => {
            registerFormVisible.value = true
        }
        const accountCreationEnabled = computed(() => {
            if (page.props.value.user) {
                return false
            }
            return true
        })
        return {
            form,
            accountCreationEnabled,
            registerFormVisible,
            showRegisterForm,
            page,
            currentRoute
        }
    }
}
</script>
